import { OxCategoriesKeys } from '@oxappsec/ox-consolidated-categories';
import { derive } from 'store-utils';
import { Nullable } from 'common-types';
import { createStore } from 'store-utils';
import { Connector } from '../connectors-types';
import ConnectorsStore from './connectors-store';

const baseStore = createStore<ConnectorConfigureState>(
  {
    originalConnector: null,
    isModalVisible: false,
    selectedConnector: null,
    isLoadingVerifyAndSaveCredentials: false,
    isLoadingRemoveCredentials: false,
    isLoadingEnableDisable: false,
    invalidForm: false,
    hostUrlErrorMsg: '',
    hostUrlValidationError: false,
    repoSelectionModalOpen: false,
    isRepoSelectionModalFirstOpen: false,
  },
  'Connector Configure Store',
);

const ConnectorConfigureStore = derive(
  {
    isSourceControlFamilyConnector: get => {
      const { selectedConnector } = get(baseStore);
      if (!selectedConnector) {
        return false;
      }

      const { connectorsByFamily } = get(ConnectorsStore);
      const sourceControlFamily = connectorsByFamily.find(
        family => family.family === OxCategoriesKeys.SourceControl,
      );

      if (!sourceControlFamily) {
        return false;
      }

      return (
        sourceControlFamily.connectors.findIndex(
          connector => connector.id === selectedConnector.id,
        ) !== -1
      );
    },
  },
  { proxy: baseStore },
);

interface ConnectorConfigureState {
  isModalVisible: boolean;
  selectedConnector: Nullable<Connector>;
  originalConnector: Nullable<Connector>;
  isLoadingVerifyAndSaveCredentials: boolean;
  isLoadingRemoveCredentials: boolean;
  isLoadingEnableDisable: boolean;
  invalidForm: boolean;
  hostUrlValidationError: boolean;
  hostUrlErrorMsg: string;
  repoSelectionModalOpen: boolean;
  isRepoSelectionModalFirstOpen: boolean;
}

export default ConnectorConfigureStore;
